import { useWeatherForecast } from '../../hooks/useWeatherForecast';
import './WeatherForecast.css';
import { Select } from '../Select';
import { formatWeatherTitle } from '../../utils/functions/formatWeatherTitle';
import { ChartDesktop } from './chart-desktop';
import { ChartMobile } from './chart-mobile';
import { StationsError } from '../RainfallTable/stations-error';
import { SkeletonChart } from '../WeatherChart/skeleton-chart';

const WeatherForecast = () => {
  const {
    isLoading: isWeatherLoading,
    selectedCity,
    cityData,
    stateData,
    selectedStateCode,
    setSelectedStateCode,
    isStatesLoading,
    setSelectedCity,
    isCitiesLoading,
    persistedWeatherData,
  } = useWeatherForecast();

  const hoje = persistedWeatherData?.hoje?.por_hora ?? [];
  const amanha = persistedWeatherData?.amanha?.por_hora ?? [];

  const allTemps = [...hoje, ...amanha].map((h) => h.temperatura);
  const allWinds = [...hoje, ...amanha].map((h) => h.vento);
  const allRain = [...hoje, ...amanha].map((h) => h.precipitacao ?? 0);

  const globalScales = {
    temp: Math.max(...allTemps),
    wind: Math.max(...allWinds),
    rain: Math.max(...allRain),
  };

  return (
    <div className="weather-forecast-container">
      <h2>
        {formatWeatherTitle(
          selectedCity,
          selectedStateCode,
          cityData,
          stateData
        )}
      </h2>

      <form className="form" aria-label="Formulário de seleção de local">
        <Select
          id="selectEstado"
          label="Estado"
          options={stateData.map((uf) => ({
            value: uf.codigo_uf,
            label: uf.nome,
          }))}
          value={selectedStateCode}
          onChange={(e) => setSelectedStateCode(Number(e.target.value))}
          disabled={isStatesLoading}
        />

        <Select
          id="selectCidade"
          label="Cidade"
          options={cityData.map((city) => ({
            value: city.ib,
            label: city.n,
          }))}
          value={selectedCity}
          onChange={(e) => setSelectedCity(Number(e.target.value))}
          disabled={isCitiesLoading}
        />
      </form>

      {isWeatherLoading ? (
        <SkeletonChart />
      ) : persistedWeatherData ? (
        <div className="container-fluid">
          <ChartMobile
            persistedWeatherData={persistedWeatherData}
            globalScales={globalScales}
          />

          <ChartDesktop
            persistedWeatherData={persistedWeatherData}
            globalScales={globalScales}
          />

          <p className="weather-source text-center mt-3">
            <strong>Fonte:</strong> European Centre for Medium-Range Weather
            Forecasts (ECMWF) e{' '}
            <a href="https://open-meteo.com/">Weather data by Open-Meteo.com</a>
          </p>
        </div>
      ) : (
        <StationsError minHeight="210px" />
      )}
    </div>
  );
};

export default WeatherForecast;
